import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { User } from 'lucide-react';

import SettingsCard from '../SettingsCard';

// Profile section of the user settings — avatar + personal info. State, refs
// and handlers live in the UserSettings shell and arrive as props.
const ProfileSection = ({
  currentAvatar,
  userInitials,
  fileInputRef,
  avatarUploading,
  handleAvatarSelect,
  handleAvatarRemove,
  personalInfo,
  handlePersonalInfoChange,
  handlePersonalInfoSubmit,
  savingProfile,
  email,
}) => (
  <SettingsCard
    id="profil"
    icon={User}
    title="Profil"
    subtitle="Hur du visas för andra och hur vi kan nå dig."
  >
    <div className="user-settings__avatar-block">
      {currentAvatar ? (
        <img src={currentAvatar} alt="Profilbild" className="user-settings__avatar" />
      ) : (
        <div className="user-settings__avatar-initials">{userInitials}</div>
      )}
      <div className="user-settings__avatar-actions">
        <input
          ref={fileInputRef}
          type="file"
          accept="image/jpeg,image/png,image/webp"
          style={{ display: 'none' }}
          onChange={handleAvatarSelect}
        />
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <Button
            variant="primary"
            size="sm"
            onClick={() => fileInputRef.current?.click()}
            disabled={avatarUploading}
          >
            {avatarUploading ? 'Laddar upp...' : currentAvatar ? 'Byt bild' : 'Ladda upp bild'}
          </Button>
          {currentAvatar && (
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={handleAvatarRemove}
              disabled={avatarUploading}
            >
              Ta bort
            </Button>
          )}
        </div>
        <small className="user-settings__meta">JPEG, PNG eller WebP. Max 2 MB.</small>
      </div>
    </div>

    <Form onSubmit={handlePersonalInfoSubmit}>
      <div className="user-settings__field-row">
        <label className="user-settings__field-label" htmlFor="formFirstName">Förnamn</label>
        <Form.Control
          id="formFirstName"
          type="text"
          name="firstName"
          value={personalInfo.firstName}
          onChange={handlePersonalInfoChange}
          placeholder="Ange förnamn"
        />
      </div>
      <div className="user-settings__field-row">
        <label className="user-settings__field-label" htmlFor="formLastName">Efternamn</label>
        <Form.Control
          id="formLastName"
          type="text"
          name="lastName"
          value={personalInfo.lastName}
          onChange={handlePersonalInfoChange}
          placeholder="Ange efternamn"
        />
      </div>
      <div className="user-settings__field-row">
        <label className="user-settings__field-label" htmlFor="formPhone">Telefonnummer</label>
        <Form.Control
          id="formPhone"
          type="tel"
          name="phoneNumber"
          value={personalInfo.phoneNumber}
          onChange={handlePersonalInfoChange}
          placeholder="Ange telefonnummer"
        />
      </div>
      <div className="user-settings__field-row">
        <label className="user-settings__field-label">E-post</label>
        <div style={{ color: '#737B8B' }}>
          {email || '—'}
          <small className="user-settings__meta" style={{ display: 'block' }}>
            Hanteras av ditt Google-konto.
          </small>
        </div>
      </div>

      <div className="user-settings__actions">
        <Button variant="primary" type="submit" disabled={savingProfile}>
          {savingProfile ? 'Sparar...' : 'Spara'}
        </Button>
      </div>
  </Form>
  </SettingsCard>
);

export default ProfileSection;
